import { Auth0Provider } from '@auth0/auth0-react';
import React from 'react';

interface Auth0ProviderWithNavigateProps {
  children: React.ReactNode;
}

export const Auth0ProviderWithNavigate: React.FC<
  Auth0ProviderWithNavigateProps
> = ({ children }) => {
  const domain = import.meta.env.REACT_APP_AUTH0_DOMAIN;
  const clientId = import.meta.env.REACT_APP_AUTH0_CLIENT_ID;
  const redirectUri = `${window.location.origin}/callback`;
  const audience = import.meta.env.REACT_APP_AUTH0_AUDIENCE;

  if (!(domain && clientId && redirectUri && audience)) {
    console.warn('[Auth0] Missing env vars, returning null');
    return null;
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      // Keep the callback session available after the SPA replaces the
      // callback URL with the destination route.
      cacheLocation="localstorage"
      authorizationParams={{
        redirect_uri: redirectUri,
        audience,
      }}
      onRedirectCallback={(appState) => {
        const returnTo = appState?.returnTo || '/dashboard';
        // Complete the Auth0 transaction with a real navigation so the router
        // mounts the destination route instead of retaining the callback page.
        window.location.replace(returnTo);
      }}
    >
      {children}
    </Auth0Provider>
  );
};
